import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useZohoDeskWidgetCallFunction } from '../util/useZohoDeskWidget';
import { UWE_HUB_TICKETS_ENABLED } from '../constants';


function Notification({ children, error, danger, ...props }) {
    const [show, setShow] = useState(true);

    if (error && !children) {
        props.color = 'danger';
        children = error.message || `${error}`;
    }
    if (children === "Failed to fetch") {
        const CreateTicketButton = UWE_HUB_TICKETS_ENABLED ? TicketsRedirectButton : ZohoDeskButton;
        children = (
            <span>Hubo un problema con la aplicación
            <CreateTicketButton style={{margin:'10px'}} color="primary">
                Crear Ticket
            </CreateTicketButton>
            </span>)
    }
    return (
        <Alert show={`${show}`} {...props} onClick={() => setShow()}>
            {children}
        </Alert>
    );
}


function ZohoDeskButton({children, ...props}){
    const zdwcf = useZohoDeskWidgetCallFunction();
    return (<Button {...props} onClick={() => zdwcf()}>{children}</Button>);
}


function TicketsRedirectButton({children, ...props}){
    const history = useHistory();
    return (<Button {...props} onClick={() => history.push('/tickets')}>{children}</Button>);
}


export default Notification;